/**
 *  All api related to system setting
 */

import _ from 'lodash'
import axios from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

function deliveryAddressData(address) {
  const {
    firstName = '',
    lastName = '',
    phone = '',
    streetLine1 = '',
    streetLine2 = '',
    district = '',
    city = '',
    state = '',
    zip = '',
    country = '',
    isBilling = false,
    isPrimary = false,
    lat,
    long
  } = address
  return {
    firstName,
    lastName,
    phone,
    street_line_1: streetLine1,
    street_line_2: streetLine2,
    district,
    city,
    state,
    zip,
    country,
    lat: _.isString(lat) ? parseFloat(lat) : _.isNumber(lat) ? lat : null,
    long: _.isString(long) ? parseFloat(long) : _.isNumber(long) ? long : null,
    isBilling,
    isPrimary
  }
}

// - create delivery address
export function createDeliveryAddresses({
  address,
  params = {},
  payload = {},
  ...otherOptions
}) {
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'createDeliveryAddresses',
    () => source.cancel('createDeliveryAddresses: Operation cancelled by user')
  )

  const deliveryAddress = deliveryAddressData(address)

  return OmnitechApi
    .request({
      endpoint: 'delivery_addresses',
      method: 'post',
      params,
      data: {
        data: {
          deliveryAddress
        },
        ...payload
      },
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      deliveryAddress: data.deliveryAddress
    }))
}

// - delete delivery address
export function deleteDeliveryAddresses({
  addressId,
  params = {},
  payload = {},
  ...otherOptions
}) {
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'deleteDeliveryAddresses',
    () => source.cancel('deleteDeliveryAddresses: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `delivery_addresses/${addressId}`,
      method: 'delete',
      params,
      data: {
        data: {
          delivery_address: {}
        },
        ...payload
      },
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      deliveryAddress: data.deliveryAddress
    }))
}

// - fetch delivery addresses
export function fetchDeliveryAddresses({
  params = {},
  ...otherOptions
}) {
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'fetchDeliveryAddresses',
    () => source.cancel('fetchDeliveryAddresses: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `delivery_addresses`,
      method: 'get',
      params,
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      deliveryAddresses: data.deliveryAddresses,
      deliveryAddressesPagination: data.deliveryAddressesPagination
    }))
}

// - update delivery address
export function updateDeliveryAddresses({
  address,
  params = {},
  payload = {},
  ...otherOptions
}) {
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'updateDeliveryAddresses',
    () => source.cancel('updateDeliveryAddresses: Operation cancelled by user')
  )

  const deliveryAddress = deliveryAddressData(address)

  return OmnitechApi
    .request({
      endpoint: `delivery_addresses/${address.id}`,
      method: 'put',
      params,
      data: {
        data: {
          deliveryAddress
        },
        ...payload
      },
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      deliveryAddress: data.deliveryAddress
    }))
}
